import React from "react";

/* 30 天接通率 sparkline：折线为每日接通率（无拨出的天留空），低于阈值的点标红，虚线为阈值 */
export function RateSparkline({ data = [], threshold = 20, width = 120, height = 28, zh = true, testid }) {
  const pts = data.filter((d) => d.c > 0);
  if (!pts.length) return <span className="text-[10px] text-slate-400" data-testid={testid}>{zh ? "30 天无拨出" : "no calls 30d"}</span>;
  const n = data.length || 1;
  const x = (i) => 2 + (i * (width - 4)) / Math.max(n - 1, 1);
  const y = (r) => height - 3 - (Math.max(0, Math.min(100, r)) * (height - 6)) / 100;
  const segs = [];
  let cur = [];
  data.forEach((d, i) => { if (d.c > 0) cur.push(`${x(i).toFixed(1)},${y(d.r).toFixed(1)}`); else if (cur.length) { segs.push(cur); cur = []; } });
  if (cur.length) segs.push(cur);
  const last = pts[pts.length - 1];
  const tone = last.r >= 40 ? "#059669" : last.r >= threshold ? "#d97706" : "#dc2626";
  return (
    <svg width={width} height={height} className="overflow-visible" data-testid={testid} data-last-rate={last.r} data-days={pts.length} role="img" aria-label={zh ? `近 30 天接通率趋势，最近 ${last.r}%` : `30-day answer rate, latest ${last.r}%`}>
      <line x1={0} x2={width} y1={y(threshold)} y2={y(threshold)} stroke="#f87171" strokeWidth={0.8} strokeDasharray="3 2" />
      {segs.map((s, i) => <polyline key={i} points={s.join(" ")} fill="none" stroke={tone} strokeWidth={1.4} strokeLinejoin="round" strokeLinecap="round" />)}
      {data.map((d, i) => d.c > 0 ? (
        <circle key={d.d} cx={x(i)} cy={y(d.r)} r={d.r < threshold ? 2.4 : 1.4} fill={d.r < threshold ? "#dc2626" : tone}>
          <title>{`${d.d} · ${zh ? "拨出" : "calls"} ${d.c} · ${zh ? "接通" : "answered"} ${d.a} · ${d.r}%`}</title>
        </circle>
      ) : null)}
    </svg>
  );
}
